import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { skipToken } from '@reduxjs/toolkit/dist/query'
import { authTokenReadySelector, loggingOutSelector, sessionExpiredSelector } from '@redux/slices/connectorSlice'
import { useGetPageFlowConfigurationQuery } from '@redux/queries/config'
import { useInsurerConfiguration } from './useInsurerConfiguration'
import { useEnvironment } from './useEnvironment'

/**
 * Fetch initial configuration once session is ready
 */
export const useInitialConfiguration = () => {
  const { brand } = useEnvironment()
  const isTokenReady = useSelector(authTokenReadySelector)
  const isLoggingOut = useSelector(loggingOutSelector)
  const isSessionExpired = useSelector(sessionExpiredSelector)

  const isReady = isTokenReady && !isLoggingOut && !isSessionExpired

  useGetPageFlowConfigurationQuery(isReady ? undefined : skipToken)

  // NOTE: skip unless brand is initialized
  // we can remove this check once the insurerDetails API is also migrated to use api keys
  const { insurers, fetchInsurerConfiguration } = useInsurerConfiguration(!brand)

  useEffect(() => {
    if (insurers?.[0]?.id && isReady) {
      fetchInsurerConfiguration(insurers[0].id)
    }
  }, [insurers, isReady])
}
